// 获取页面参数
const getUrlpar = () => {
  const theRequest = {};
  const url = window.location.search || '';
  if (url.indexOf('?') !== -1) {
    const str = url.substr(1);
    const strs = str.split('&');
    for (let i = 0; i < strs.length; i += 1) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
  }
  return theRequest;
};

export default {
  getUrlpar,
};
